var React = require('react');

function Cancel (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_11_291)","key":0},React.createElement("path",{"d":"M13.414 11.994L23.7072 1.70084C24.0909 1.30361 24.0799 0.67051 23.6827 0.286831C23.2952 -0.0874724 22.6807 -0.0874724 22.2932 0.286831L12 10.58L1.7068 0.286831C1.30952 -0.0968475 0.676465 -0.0858317 0.292786 0.311394C-0.081517 0.698916 -0.081517 1.31332 0.292786 1.70084L10.586 11.994L0.292786 22.2872C-0.0975954 22.6777 -0.0975954 23.3107 0.292786 23.7012C0.683309 24.0916 1.31632 24.0916 1.7068 23.7012L12 13.408L22.2932 23.7012C22.6837 24.0916 23.3167 24.0916 23.7072 23.7012C24.0975 23.3107 24.0975 22.6777 23.7072 22.2872L13.414 11.994Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_11_291"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

Cancel.defaultProps = {"fill":"none"};

module.exports = Cancel;

Cancel.default = Cancel;
